import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from './loading.service';

// Conta as chamadas em andamento pro LoadingService saber quando a tela terminou de carregar
@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  constructor(
    public loading: LoadingService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loading.requisicaoIniciou();
    return next.handle(req).pipe(
      finalize(() => this.loading.requisicaoTerminou())
    );
  }
}
